export default __webpack_public_path__ + "static/amazon-business-e7cdf4c09fa08bf722f4cf1a921cd6c1.svg";